import { Texts, Title, Media, Button } from "../Object";
import { Space } from "../Layout";
import { NewsList } from '../Post';

const News = () => {
  return(
    <>
      <div className="l-row">
        <div className="c-grid__news">
          <div className="pc">
            <NewsList noimage={false} perPage={1}></NewsList>
          </div>

          <div>
            <div className="c-grid__wrap--title-button">
              <Texts slug="title/news" class="c-text--main c-text--en c-text--big"></Texts>
              <div className="pc">
                <Button link="/posts/" slug="news"></Button>
              </div>
            </div>
            <Space size={['40px 0 0', '32px 0 48px']}>
              <div className="sp">
                <Space size={['0', '0 0 32px']}>
                  <NewsList noimage={false} perPage={1}></NewsList>
                </Space>
              </div>
              <NewsList noimage={true} perPage={3} offset={1}></NewsList>
            </Space>
            <div className="sp">
              <Button link="/posts/" slug="news"></Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default News;